import crud from '@/crud/index/index'

import data from './data'
import methods from './methods'
import mounted from './mounted'

export default {
  data,
  methods,
  mounted,

  mixins: [crud],

  resourcePath: 'v1/search/professionals/statistic?limit=false&pagination=false'
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/statistics/resources/index.js